module.exports = __webpack_public_path__ + "images/arrow_1-a6874dbe.png";